import * as React from 'react';
import { ImageContainer, PageContainer, ContentContainer, ChildrenContainer, } from './JoinByInviteContainerStyles';
import { useMediaQuery } from '../../core/Common/MediaQueryProvider';
var JoinByInviteLayout = function (_a) {
    var children = _a.children, contentMaxWidthPx = _a.contentMaxWidthPx;
    var isMobile = useMediaQuery().isMobile;
    return (React.createElement(PageContainer, null,
        !isMobile && React.createElement(ImageContainer, null),
        React.createElement(ContentContainer, null,
            React.createElement(ChildrenContainer, { maxWidthPx: contentMaxWidthPx }, children))));
};
export default JoinByInviteLayout;
